// source: tableau/metrics/models/data_values.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return window;
}.call(null));

goog.exportSymbol('proto.tableau.metrics.models.p4.DataValue', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.DataValue.ValueCase', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.DataValues', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.DateTime', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.FieldIdentifier', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.DataValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.tableau.metrics.models.p4.DataValue.oneofGroups_);
};
goog.inherits(proto.tableau.metrics.models.p4.DataValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.DataValue.displayName = 'proto.tableau.metrics.models.p4.DataValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.DataValues = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tableau.metrics.models.p4.DataValues.repeatedFields_, null);
};
goog.inherits(proto.tableau.metrics.models.p4.DataValues, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.DataValues.displayName = 'proto.tableau.metrics.models.p4.DataValues';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.DateTime = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tableau.metrics.models.p4.DateTime, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.DateTime.displayName = 'proto.tableau.metrics.models.p4.DateTime';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.FieldIdentifier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tableau.metrics.models.p4.FieldIdentifier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.FieldIdentifier.displayName = 'proto.tableau.metrics.models.p4.FieldIdentifier';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.tableau.metrics.models.p4.DataValue.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.tableau.metrics.models.p4.DataValue.ValueCase = {
  VALUE_NOT_SET: 0,
  STRING_VALUE: 1,
  LONG_VALUE: 2,
  DOUBLE_VALUE: 3,
  DATE_TIME_VALUE: 4,
  BOOL_VALUE: 5
};

/**
 * @return {proto.tableau.metrics.models.p4.DataValue.ValueCase}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.getValueCase = function() {
  return /** @type {proto.tableau.metrics.models.p4.DataValue.ValueCase} */(jspb.Message.computeOneofCase(this, proto.tableau.metrics.models.p4.DataValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.DataValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.DataValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.DataValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    stringValue: jspb.Message.getFieldWithDefault(msg, 1, ""),
    longValue: jspb.Message.getFieldWithDefault(msg, 2, 0),
    doubleValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    dateTimeValue: (f = msg.getDateTimeValue()) && proto.tableau.metrics.models.p4.DateTime.toObject(includeInstance, f),
    boolValue: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.DataValue}
 */
proto.tableau.metrics.models.p4.DataValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.DataValue;
  return proto.tableau.metrics.models.p4.DataValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.DataValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.DataValue}
 */
proto.tableau.metrics.models.p4.DataValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStringValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLongValue(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDoubleValue(value);
      break;
    case 4:
      var value = new proto.tableau.metrics.models.p4.DateTime;
      reader.readMessage(value,proto.tableau.metrics.models.p4.DateTime.deserializeBinaryFromReader);
      msg.setDateTimeValue(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBoolValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.DataValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.DataValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.DataValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getDateTimeValue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.tableau.metrics.models.p4.DateTime.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string string_value = 1;
 * @return {string}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.getStringValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tableau.metrics.models.p4.DataValue} returns this
 */
proto.tableau.metrics.models.p4.DataValue.prototype.setStringValue = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.tableau.metrics.models.p4.DataValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.DataValue} returns this
 */
proto.tableau.metrics.models.p4.DataValue.prototype.clearStringValue = function() {
  return jspb.Message.setOneofField(this, 1, proto.tableau.metrics.models.p4.DataValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.hasStringValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 long_value = 2;
 * @return {number}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.getLongValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tableau.metrics.models.p4.DataValue} returns this
 */
proto.tableau.metrics.models.p4.DataValue.prototype.setLongValue = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.tableau.metrics.models.p4.DataValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.DataValue} returns this
 */
proto.tableau.metrics.models.p4.DataValue.prototype.clearLongValue = function() {
  return jspb.Message.setOneofField(this, 2, proto.tableau.metrics.models.p4.DataValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.hasLongValue = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double double_value = 3;
 * @return {number}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.getDoubleValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tableau.metrics.models.p4.DataValue} returns this
 */
proto.tableau.metrics.models.p4.DataValue.prototype.setDoubleValue = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.tableau.metrics.models.p4.DataValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.DataValue} returns this
 */
proto.tableau.metrics.models.p4.DataValue.prototype.clearDoubleValue = function() {
  return jspb.Message.setOneofField(this, 3, proto.tableau.metrics.models.p4.DataValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.hasDoubleValue = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional DateTime date_time_value = 4;
 * @return {?proto.tableau.metrics.models.p4.DateTime}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.getDateTimeValue = function() {
  return /** @type{?proto.tableau.metrics.models.p4.DateTime} */ (
    jspb.Message.getWrapperField(this, proto.tableau.metrics.models.p4.DateTime, 4));
};


/**
 * @param {?proto.tableau.metrics.models.p4.DateTime|undefined} value
 * @return {!proto.tableau.metrics.models.p4.DataValue} returns this
*/
proto.tableau.metrics.models.p4.DataValue.prototype.setDateTimeValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.tableau.metrics.models.p4.DataValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.DataValue} returns this
 */
proto.tableau.metrics.models.p4.DataValue.prototype.clearDateTimeValue = function() {
  return this.setDateTimeValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.hasDateTimeValue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool bool_value = 5;
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.getBoolValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tableau.metrics.models.p4.DataValue} returns this
 */
proto.tableau.metrics.models.p4.DataValue.prototype.setBoolValue = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.tableau.metrics.models.p4.DataValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.DataValue} returns this
 */
proto.tableau.metrics.models.p4.DataValue.prototype.clearBoolValue = function() {
  return jspb.Message.setOneofField(this, 5, proto.tableau.metrics.models.p4.DataValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.DataValue.prototype.hasBoolValue = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tableau.metrics.models.p4.DataValues.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.DataValues.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.DataValues.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.DataValues} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.DataValues.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    proto.tableau.metrics.models.p4.DataValue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.DataValues}
 */
proto.tableau.metrics.models.p4.DataValues.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.DataValues;
  return proto.tableau.metrics.models.p4.DataValues.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.DataValues} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.DataValues}
 */
proto.tableau.metrics.models.p4.DataValues.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tableau.metrics.models.p4.DataValue;
      reader.readMessage(value,proto.tableau.metrics.models.p4.DataValue.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.DataValues.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.DataValues.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.DataValues} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.DataValues.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tableau.metrics.models.p4.DataValue.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DataValue values = 1;
 * @return {!Array<!proto.tableau.metrics.models.p4.DataValue>}
 */
proto.tableau.metrics.models.p4.DataValues.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.tableau.metrics.models.p4.DataValue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tableau.metrics.models.p4.DataValue, 1));
};


/**
 * @param {!Array<!proto.tableau.metrics.models.p4.DataValue>} value
 * @return {!proto.tableau.metrics.models.p4.DataValues} returns this
*/
proto.tableau.metrics.models.p4.DataValues.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tableau.metrics.models.p4.DataValue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tableau.metrics.models.p4.DataValue}
 */
proto.tableau.metrics.models.p4.DataValues.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tableau.metrics.models.p4.DataValue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tableau.metrics.models.p4.DataValues} returns this
 */
proto.tableau.metrics.models.p4.DataValues.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.DateTime.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.DateTime.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.DateTime} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.DateTime.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateTime: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.DateTime}
 */
proto.tableau.metrics.models.p4.DateTime.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.DateTime;
  return proto.tableau.metrics.models.p4.DateTime.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.DateTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.DateTime}
 */
proto.tableau.metrics.models.p4.DateTime.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.DateTime.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.DateTime.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.DateTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.DateTime.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateTime();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string date_time = 1;
 * @return {string}
 */
proto.tableau.metrics.models.p4.DateTime.prototype.getDateTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tableau.metrics.models.p4.DateTime} returns this
 */
proto.tableau.metrics.models.p4.DateTime.prototype.setDateTime = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.FieldIdentifier.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.FieldIdentifier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.FieldIdentifier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.FieldIdentifier.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.FieldIdentifier}
 */
proto.tableau.metrics.models.p4.FieldIdentifier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.FieldIdentifier;
  return proto.tableau.metrics.models.p4.FieldIdentifier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.FieldIdentifier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.FieldIdentifier}
 */
proto.tableau.metrics.models.p4.FieldIdentifier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.FieldIdentifier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.FieldIdentifier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.FieldIdentifier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.FieldIdentifier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string field_name = 1;
 * @return {string}
 */
proto.tableau.metrics.models.p4.FieldIdentifier.prototype.getFieldName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tableau.metrics.models.p4.FieldIdentifier} returns this
 */
proto.tableau.metrics.models.p4.FieldIdentifier.prototype.setFieldName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.tableau.metrics.models.p4);
